export function toggleAttribute(el, name, boolValue) {
  if (!el) {
    return
  }

  let nextValue
  if (typeof boolValue !== 'undefined') {
    nextValue = !!boolValue
  } else {
    nextValue = el.hasAttribute(name)
  }

  if (nextValue) {
    el.setAttribute(name, '')
  } else {
    el.removeAttribute(name)
  }
}

export function setAttribute(el, name, nextValue) {
  if (!el) {
    return
  }

  if (nextValue) {
    el.setAttribute(name, nextValue)
  } else {
    el.removeAttribute(name)
  }
}

export const closest = (() => {
  const proto = typeof window === 'undefined' ? {} : window.Element.prototype
  const match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector
  if (proto.closest) {
    return (el, css) => el.closest(css)
  } else {
    return (el, css) => {
      for (; el; el = el.parentElement) if (match.call(el, css)) return el
      return null
    }
  }
})()

export function addStyle(nodeName, css) {
  const key = `style-${nodeName.toLowerCase()}`
  const min = css.replace(/\/\*[^!][^*]*\*\//g, '').replace(/\s*(^|[:;,{}]|$)\s*/g, '$1')
  document.getElementById(key) ||
    document.head.insertAdjacentHTML('afterbegin', `<style id="${key}">${min}</style>`)
}

export function toArray(nodeList) {
  return [].slice.call(nodeList)
}

export function dispatchEvent(element, name, detail = {}) {
  const ignore = `prevent_recursive_dispatch_maximum_callstack${name}`
  let event

  if (element[ignore]) return true
  // We are already processing this event, so skip sending a new one
  else element[ignore] = true // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, { bubbles: true, cancelable: true, detail })
  } else {
    event = document.createEvent('CustomEvent')
    event.initCustomEvent(name, true, true, detail)
  }
  // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent
  const result = element.dispatchEvent(event)
  element[ignore] = null // Remove name from dispatching ignore

  return result // Follow W3C standard for return value
}
